define('views/base/table',['require','underscore','lib/utils','views/base/view'],function(require) {
    'use strict';

    var _ = require('underscore'),
            utils = require('lib/utils'),
        View = require('views/base/view');

    var TableView = View.extend({
        autoRender: true,
        windowResize: true,

        template: '<table class="datatable" cellspacing="0"><thead><tr></tr></thead> <tfoot><tr class="filter-row"></tr></tfoot></table>',

        columns: [],
        bottomPadding: 12,

        optionNames: View.prototype.optionNames.concat([
            'columns',
            'bottomPadding'
        ]),

        initialize: function() {
            View.prototype.initialize.apply(this, arguments);

            this.listenTo(this.model, 'change:search', this.onSearch);
            this.listenTo(this.model, 'change:items', this.onSetItems);
            this.listenTo(this.model, 'sync', this.onFinishFetch);
            this.listenTo(this.model, 'request', this.onStartFetch);

        },

        onFinishFetch: function() {
            this.$('.dataTables_scrollBody').removeClass('preloader');
            this.onSetItems();
        },

        onStartFetch: function() {
            this.$('.dataTables_scrollBody').addClass('preloader');
        },

        initializeTable: function() {
            var view = this;
            var model = this.model;

            var table = this.$('.datatable')
                .DataTable({
                    deferRender:    true,
                    scrollY:        500,
                    scrollCollapse: false,
                    scroller:       true,
                    dom: 'tr',
                    language: {
                       zeroRecords: 'Нет данных для отображения',
                       loadingRecords: ' '
                    },
                    data: model.get('items') || [],
                    columns: this.columns,
                    drawCallback: function() {
                        view.trigger('redraw');
                    }
                })
                .on('xhr', function () {
                    view.$('.dataTables_scrollBody').removeClass('preloader');
                })
                .on('mousedown', 'tr', function () {
                    table.$('tr.selected').removeClass('selected');
                    $(this).addClass('selected');

                    model.set('selected', table.row( this ).data());
                });


            this.dt = table;

            view.$('.dataTables_scrollBody').addClass('preloader');
        },

        resizeTable: function() {
            var bodyHeight = $('body').height();
            var $tableBody = this.$('.dataTables_scrollBody');
            var tableBodyTop = $tableBody.offset().top;

            $tableBody.css('height', bodyHeight - tableBodyTop - this.bottomPadding);
        },

        onSearch: function() {
            this.dt.search(this.model.get('search')).draw();
        },

        onSetItems: function() {
            var items = (this.collection ? this.collection.toJSON() : this.model.get('items')) || [];

            if (this.dt) {
                this.dt.clear();
                this.dt.rows.add(items);
                this.dt.draw();

                this.onWindowResize();
            }
        },

        update: function() {
            this.onSetItems();
        },

        isTableInitialized: function() {
            return !!this.dt;
        },

        onWindowResize: function() {

            if (!this.isTableInitialized()) {
                this.initializeTable();
            }

            this.resizeTable();
        }
    });

    return TableView;
});

